export function dayOfYear(date) {
	//const d1 = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	const d1 = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
	//const d2 = Date.UTC(date.getUTCFullYear(), 0, 0);
	const d2 = new Date(date.getFullYear(), 0, 0).getTime();
	//console.log(d1, d2, Math.round((d1 - d2) / 24 / 60 / 60 / 1000 ));
	return Math.round((d1 - d2) / 24 / 60 / 60 / 1000);
}
